/**
 * Device detection utilities
 */

export function isMobileDevice(): boolean {
  // Check if running in standalone mode (installed PWA)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }

  // Check user agent for mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Mobile patterns
  const mobilePatterns = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return mobilePatterns.some(pattern => userAgent.match(pattern));
}

export function isDesktopDevice(): boolean {
  return !isMobileDevice();
}

export function isStandalone(): boolean {
  // Check if app is running as installed PWA
  return window.matchMedia('(display-mode: standalone)').matches ||
         (window.navigator as any).standalone === true; // iOS
}

export function canInstallPWA(): boolean {
  // Will be set when beforeinstallprompt event fires
  return (window as any).deferredPrompt !== undefined;
}

export interface DeviceInfo {
  isMobile: boolean;
  isDesktop: boolean;
  isStandalone: boolean;
  canInstall: boolean;
  userAgent: string;
  screenWidth: number;
  screenHeight: number;
}

export function getDeviceInfo(): DeviceInfo {
  return {
    isMobile: isMobileDevice(),
    isDesktop: isDesktopDevice(),
    isStandalone: isStandalone(),
    canInstall: canInstallPWA(),
    userAgent: navigator.userAgent,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
  };
}
